/*
 * File: UISwitch.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Formatting for a Switch input element
 */
import React from "react";
import Switch from "@material-ui/core/Switch";
import PropTypes from "prop-types";
import { ListItem, makeStyles, ListItemText } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  listItem: {
    flexWrap: "wrap",
    paddingLeft: theme.spacing(2)
  },
  root: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1)
  }
}));

const UISwitch = ({ field, onChange, value }) => {
  const classes = useStyles();
  const handleChange = event => {
    if (typeof onChange === "function") {
      onChange(event);
    } else if (typeof field.update === "function") {
      field.update(event.target.checked);
    }
  };

  return (
    <div className={classes.root}>
      {field.title && (
        <ListItem disableGutters>
          <ListItemText
            primary={field.title}
            primaryTypographyProps={{
              variant: "subtitle1",
              style: { fontSize: "1.25rem" }
            }}
          />
        </ListItem>
      )}
      <ListItem disableGutters className={classes.listItem}>
        <ListItemText>{field.label}</ListItemText>
        <Switch
          onChange={handleChange}
          checked={value}
          value={value}
          color="primary"
          name={field.name}
          id={field.id}
        />
      </ListItem>
    </div>
  );
};

UISwitch.propTypes = {
  field: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.bool
};

export default UISwitch;
